import styled from 'styled-components';

export const IconContainer = styled.div`
  padding-left: 15px;
`;

export const Icon = styled.img``;

export default { IconContainer, Icon };
